module.exports = require("vue3-carousel/dist/carousel.css");